import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import useAuth from '../hooks/useAuth';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (isAuthenticated) {
    navigate('/dashboard', { replace: true });
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Please enter email and password');
      return;
    }
    setSubmitting(true);
    try {
      await login(email, password, rememberMe);
      toast.success('Welcome back!');
      const from = location.state?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.message || err.message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7FAFC] flex items-center justify-center p-4">
      <div className="w-full max-w-md">

        {/* Hero logo */}
        <div className="text-center mb-8">
          <div className="inline-block p-1">
            <img
              src="/Logo.png"
              alt="FREAC"
              className="mx-auto w-48 h-48 rounded-3xl object-cover shadow-[0_12px_32px_rgba(25,211,230,.15)]"
            />
          </div>
          <p className="text-[#667085] mt-3 text-sm tracking-widest font-medium uppercase">
            Admin Portal
          </p>
        </div>

        {/* Form card */}
        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-[20px] border border-[#EAECF0] p-8 space-y-5
                     shadow-[0_6px_18px_rgba(0,0,0,.06)]"
        >
          <div>
            <label className="admin-label">Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="admin-input"
              placeholder="admin@example.com"
              autoComplete="email"
            />
          </div>

          <div>
            <label className="admin-label">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="admin-input"
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div>

          <label className="flex items-center gap-2.5 cursor-pointer">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              className="w-4 h-4 rounded border-[#D0D5DD] text-[#19D3E6] focus:ring-[#19D3E6]"
            />
            <span className="text-sm text-[#667085]">Remember me</span>
          </label>

          <p className="text-center text-sm text-[#667085]">
            Don't have an account?{' '}
            <Link
              to="/register"
              className="text-[#19D3E6] hover:text-[#00B8D9] font-semibold transition-colors"
            >
              Register here
            </Link>
          </p>

          <button
            type="submit"
            disabled={submitting}
            className="admin-btn-primary w-full"
          >
            {submitting ? (
              <span className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Signing in...
              </span>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
